/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import {
  Expression,
  Icon,
  List,
  SiteSection,
  SiteSectionDescription,
  SiteSectionMovePosition,
  SiteSectionPath,
  SiteSectionTitle,
} from "./data-contracts";

/**
 * No description
 * @tags site-sections
 * @name AddSectionToSite
 * @summary Add a section to a site
 * @request POST:/orgs/{organizationId}/sites/{siteId}/sections
 * @secure
 */

// @ts-ignore
export const addSectionToSite: {
  route: string;
  method: "post";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {};
  RequestBody: {
    /** ID of the space to be added to the section as a site space variant */
    spaceId: string;
    title?: SiteSectionTitle | null;
    icon?: Icon | null;
  };
  RequestHeaders: {};
  ResponseBody: SiteSection;
  ResponseStatusCode: 201;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/sections",
  method: "post",
  streaming: false,
  tags: ["site-sections"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags site-sections
 * @name ListSiteSections
 * @summary List all site sections
 * @request GET:/orgs/{organizationId}/sites/{siteId}/sections
 * @secure
 */

// @ts-ignore
export const listSiteSections: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {
    /** For sites published via share-links, the share key is useful to resolve published URLs. */
    shareKey?: string;
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: SiteSection[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/sections",
  method: "get",
  streaming: false,
  tags: ["site-sections"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags site-sections
 * @name UpdateSiteSectionById
 * @summary Update a site section
 * @request PATCH:/orgs/{organizationId}/sites/{siteId}/sections/{siteSectionId}
 * @secure
 */

// @ts-ignore
export const updateSiteSectionById: {
  route: string;
  method: "patch";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique id of the site */
    siteId: string;
    /** The unique id of the section within a site */
    siteSectionId: string;
  };
  RequestQuery: {};
  RequestBody: {
    /** Title of the site section */
    title?: SiteSectionTitle;
    /** Path to the section on the site */
    path?: SiteSectionPath;
    /** ID of the site-space to be used as the default in this section. */
    defaultSiteSpace?: string;
    /** Conditional expression used to evaluate whether the site section should be shown to the site's visitor (should evaluate to a boolean). If not set, the condition will remain unchanged. If set to null, the condition will be removed. */
    condition?: Expression | null;
    icon?: Icon | null;
    description?: SiteSectionDescription | null;
  };
  RequestHeaders: {};
  ResponseBody: SiteSection;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/sections/{siteSectionId}",
  method: "patch",
  streaming: false,
  tags: ["site-sections"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags site-sections
 * @name DeleteSiteSectionById
 * @summary Delete a site section
 * @request DELETE:/orgs/{organizationId}/sites/{siteId}/sections/{siteSectionId}
 * @secure
 */

// @ts-ignore
export const deleteSiteSectionById: {
  route: string;
  method: "delete";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique id of the site */
    siteId: string;
    /** The unique id of the section within a site */
    siteSectionId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 205;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/sections/{siteSectionId}",
  method: "delete",
  streaming: false,
  tags: ["site-sections"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags site-sections
 * @name MoveSiteSection
 * @summary Move a site section to a new position. (Deprecated) use sortSiteStructure instead.
 * @request POST:/orgs/{organizationId}/sites/{siteId}/sections/{siteSectionId}/move
 * @deprecated
 * @secure
 */

// @ts-ignore
export const moveSiteSection: {
  route: string;
  method: "post";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique id of the site */
    siteId: string;
    /** The unique id of the section within a site */
    siteSectionId: string;
  };
  RequestQuery: {};
  RequestBody: {
    /** The position where to move the site section. When not provided the site section is moved at the end of the site. */
    position?: SiteSectionMovePosition;
  };
  RequestHeaders: {};
  ResponseBody: SiteSection;
  ResponseStatusCode: 200 | 400 | 404;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/sections/{siteSectionId}/move",
  method: "post",
  streaming: false,
  tags: ["site-sections"],
  criticalityLevel: "low",
  deprecated: { errorRate: 0 },
};
